export interface TraceabilityStep {
  execution_id: number;
  work_id: number | null;
  work_name: string | null;
  work_type: 'origin' | 'transfer' | 'destiny' | 'data' | string | null;
  status: 'success' | 'error' | 'omitted' | 'skipped' | 'processing';
  started_at: string;
  matched_in: 'id_origin' | 'id_destiny' | null;
  excerpt: string;
  message: string;
  has_payload: boolean;
}

export interface TraceabilityRun {
  execution_list_id: number | null;
  workflow_id: number | null;
  workflow_name: string | null;
  status: string;
  started_at: string;
  steps: TraceabilityStep[];
}

export interface TraceabilitySummary {
  total_executions: number;
  distinct_workflows: number;
  last_status: string | null;
  first_seen: string | null;
  last_seen: string | null;
}

export interface TraceabilityResponse {
  identifier: string;
  variants_used: string[];
  matched_ids_count: number;
  executions_count: number;
  page: number;
  page_size: number;
  summary: TraceabilitySummary;
  runs: TraceabilityRun[];
  unicode_warnings: unknown[];
}

export interface DeepSearchMatch {
  execution_id: number;
  work_id: number | null;
  status: string;
  started_at: string;
  message: string;
  workflow_id: number | null;
  execution_list_id: number | null;
}

export interface TraceabilityDeepResponse {
  identifier: string;
  mode: 'deep';
  matched_ids_count: number;
  matched_ids: number[];
  matches: DeepSearchMatch[];
  partial: boolean;
  windows_checked: number;
  date_from: string;
  date_to: string;
  error?: string;
}

export interface TraceabilitySearchParams {
  identifier: string;
  mode?: 'fast' | 'deep';
  field?: string;
  dateFrom?: string;
  dateTo?: string;
  status?: string[];
  page?: number;
  pageSize?: number;
}

export interface TraceabilitySearchOptions {
  origin_keys: string[];
}

export interface WorkExecutionDetail {
  id: number;
  work: number;
  status: string;
  message: string;
  request: string | null;
  response: string | null;
  started_at: string;
  type: string;
  data: string | null;
  id_origin: string | null;
  id_destiny: string | null;
}